"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InstructorSignDocumentController = /** @class */ (function () {
    function InstructorSignDocumentController($stateParams, UserService, FlashService) {
        this.$stateParams = $stateParams;
        this.UserService = UserService;
        this.FlashService = FlashService;
        this.userRole = "instructor";
        this.handleSignatureAdded = this.handleSignatureAdded.bind(this);
        this.handleError = this.handleError.bind(this);
        var currentUser = UserService.getCurrentUser();
        this.documentId = parseInt($stateParams.documentId, 10);
        this.userId = currentUser.id;
    }
    InstructorSignDocumentController.prototype.handleSignatureAdded = function (signatureData) {
        var fieldId = signatureData.document_field_id;
        this.FlashService.setMessage({
            type: "success",
            message: "Signature for field ".concat(fieldId, " saved successfully!"),
        });
    };
    InstructorSignDocumentController.prototype.handleError = function (error) {
        this.FlashService.setMessage({
            type: "error",
            message: error.message || "An error occurred while processing your signature.",
        });
    };
    InstructorSignDocumentController.$inject = [
        "$stateParams",
        "UserService",
        "FlashService",
    ];
    return InstructorSignDocumentController;
}());
exports.default = InstructorSignDocumentController;
